import { TOOL } from '@/api/apiModules'
export default {
  viewType: 'table',
  module: TOOL,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  params: {
    toolStatus: 'ON_SHELF'
  },
  toolbar: {
    searchWidth: 300,
    searchPlaceholder: '程序名称/工具名称',
    searchFieldNameArr: ['toolName', 'toolDesc']
  },
  view: {
    columns: [
      {
        type: 'radio',
        width: 55
      },
      {
        props: {
          label: '工具名称',
          prop: 'toolDesc',
          sortField: 'toolDesc',
          width: 180
        }
      },
      {
        props: {
          label: '工具用途',
          prop: 'toolDetail'
        }
      },
      {
        props: {
          label: '工具来源',
          prop: 'toolSource',
          sortField: 'toolSource',
          width: 120
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'toolSource'
      },
      {
        props: {
          label: '状态',
          prop: 'toolStatus',
          sortField: 'toolStatus',
          width: 100
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'toolStatus'
      },
      {
        props: {
          label: '创建人',
          prop: 'realName',
          width: 100
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 160
        },
        dataType: 'date'
      }
    ]
  }
}
